export enum Dokument {
  BEIBLATT_MIT_SEPA = 'BEIBLATT_MIT_SEPA',
  BEIBLATT_OHNE_SEPA = 'BEIBLATT_OHNE_SEPA',
  INFOPAKET = 'INFOPAKET',
  PKB = 'PKB',
  WEWE = 'WEWE',
  JAGDBESTAETIGUNG = 'JAGDBESTAETIGUNG',
}
